<div class="settings-item !items-start">
    <div class="heading-wrapper">
        <div class="description">
            <div class="settings-header">
                <div class="with-label">
                    Back-count
                    <app-badge [color]="BadgeColorsEnum.Green">beta</app-badge>
                </div>
            </div>
            <div *ngIf="!backCountEnabled; else elseBlock" class="settings-sub-header">
                Require a back-count when recording all or select transactions
            </div>
            <ng-template #elseBlock>
                <div class="flex flex-row">
                    <div class="checkmark-rounded mt-[2px] ml-1"></div>
                    <div class="settings-sub-header">
                        <div *ngIf="backCountEnabled" class="template">
                            <div>Transactions for back-count</div>
                            <div class="description"> {{selectedActivitiesString}}</div>
                        </div>
                    </div>  
                </div>
            </ng-template>
    
        </div>
    </div>
    <div class="controls">
        <div class="switch" (click)="onSwitchClick()">
            <img class="toggle-switch" [class.hidden]="backCountEnabled" src="assets/icons/icon-slide-switch-is-off.svg"
                alt="off" title="off" />
            <img class="toggle-switch" [class.hidden]="!backCountEnabled" src="assets/icons/icon-slide-switch-is-on.svg"
                alt="on" title="on" />
        </div>
        <app-button class="edit" *ngIf="backCountEnabled"
            styleClass="settings" subStyle="blue" [minWidth]="0"
            (clicked)="editBackCountConfigurationClicked()">
            Edit
        </app-button>
    </div>
</div>

<app-dialog *ngIf="displaySelectActivitiesDialog"
  header="Transactions for back-count"
  subHeader="Confirm the activities and drug schedules that require a back-count."
  [maxWidth]="576"
  [minWidth]="576"
  [show]="true"
  [hasControls]="true"
  [hideHeaderUnderline]="true"
  [hideControlsDivider]="true"
  saveBtnText="Confirm"
  (cancel)="selectedActivityIDs = []; displaySelectActivitiesDialog = false"
  (save)="saveSelectedActivities()">
  <div class="groups-container not-default-scrollbar" appOverflowClass>
    <div *ngFor="let group of activityWithSchedulesGroups;" class="check-group-item">
        <app-checkbox-group
         [option]="group" 
         countedItemsHeader="Schedule">
        </app-checkbox-group>
    </div>
  </div>
</app-dialog>